import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';

import { setupGlobalErrorHandling } from '@/utils/setupGlobalErrorHandling';

if (import.meta.env.DEV) {
  setupGlobalErrorHandling();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.Fragment>
    <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </HashRouter>
  </React.Fragment>
);

serviceWorker.unregister();
